import styled from 'styled-components';

export const ButtonContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 3;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: ${(props) =>
    props.pristine ? 'all 500ms ease-in-out 3390ms' : 'all 500ms ease-in-out'};
`;
